<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="133" height="30" viewBox="0 0 133 30" fill="none">
        <ellipse cx="52.1066" cy="14.8072" rx="14.8876" ry="14.7955" fill="#F6C407"/>
        <rect x="19.1545" width="11.1735" height="23.653" fill="#399ADB"/>
        <path d="M105.276 0.0117188H69.6526L87.4645 29.6028L105.276 0.0117188Z" fill="#0676C2"/>
        <path d="M97.3009 29.6025L132.925 29.6025L115.113 0.0114841L97.3009 29.6025Z" fill="#399ADB"/>
        <path d="M0 0V29.6025H30.3281V22.4921L9.28706 0H0Z" fill="#0676C2"/>
        <path d="M11.1733 18.7188V29.6207H21.2756L11.1733 18.7188Z" fill="#399ADB"/>
        <path d="M0 10.9131V19.7385H9.57059L0 10.9131Z" fill="white"/>
        <rect y="9.35645" width="9.57059" height="20.2465" fill="#0676C2"/>
        <path d="M11.1658 18.7002V29.6022H8.01086e-05L11.1658 18.7002Z" fill="#034C80"/>
    </svg>
</template>
